define('CustomPLP.EntryPoint', [
  'Facets.Browse.View',
  'FacetsItemsCollectionView',
  'Facets.ItemCell.View',
  'CustomPLP.AddToCart.View',
  'CustomCategory.Model',
  'Configuration',
  'jQuery',
  'underscore',
  'customplp.tpl',
  'facets_facet_browse_ext.tpl'
], function (
  FacetsBrowseView,
  FacetsItemsCollectionView,
  FacetsItemCellView,
  CustomPLPAddToCartView,
  CustomCategoryModel,
  Configuration,
  jQuery,
  _,
  customplp_tpl,
  facets_facet_browse_ext_tpl
) {
  'use strict';

  var firstTimeIn = true;

  // Same Item Option id CustomPLP.AddToCart.View.js checks for. An item
  // requiring artwork can't be completed from this cell at all (no upload UI
  // here), so Quick View shouldn't offer a second add-to-cart path either.
  var ARTWORK_CONFIG = Configuration.ArtworkUpload || {};
  var ARTWORK_CART_OPTION_ID = ARTWORK_CONFIG.cartOptionId || 'custcol_artwork_file';

  function itemRequiresArtwork(model) {
    var itemOptions = model && model.get('options');
    return !!(itemOptions && itemOptions.find(function (option) {
      return option.attributes && option.attributes.cartOptionId === ARTWORK_CART_OPTION_ID;
    }));
  }

  function isDisplayListView() {
    return getUrlDisplayParameter() === 'list';
  }

  function isCustomPlpEnabled(categoryModel, customCategoryData) {
    return (
      categoryModel &&
      customCategoryData &&
      customCategoryData.custrecord155 == 'T'
    );
  }

  function getUrlDisplayParameter() {
    var search = window.location.search;

    /**
     * Also check in the hash to keep the extension functional
     * when working locally.
     */
    if (window.location.hash) {
      var hash = window.location.hash;
      var hashParamsIndex = hash.indexOf('?');
      if (hashParamsIndex !== -1) {
        search = hash.substring(hashParamsIndex);
      }
    }

    var urlParams = new URLSearchParams(search);
    return urlParams.get('display');
  }

  function setUrlDisplayParameterToList() {
    var url = window.location.href;
    var hasHash = url.indexOf('#') !== -1;
    var hashIndex = hasHash ? url.indexOf('#') : -1;
    var baseUrl = hasHash ? url.substring(0, hashIndex) : url;
    var hash = hasHash ? url.substring(hashIndex + 1) : '';
    var hashParamsIndex = hash.indexOf('?');
    var hasQueryParams = hashParamsIndex !== -1;
    var hashBase = hasQueryParams ? hash.substring(0, hashParamsIndex) : hash;
    var hashSearch = hasQueryParams ? hash.substring(hashParamsIndex) : '';

    var searchParams = new URLSearchParams(hashSearch);
    searchParams.set('display', 'list');
    var newHash = hashBase + '?' + searchParams.toString();

    window.location.href = baseUrl + '#' + newHash;
  }

  function getPlpDisplay() {
    var PLP =
      window.SC &&
      SC.Application &&
      SC.Application.getComponent &&
      SC.Application.getComponent('PLP');

    return PLP && PLP.getDisplay && PLP.getDisplay();
  }

  function setPlpDisplay(display) {
    var PLP =
      window.SC &&
      SC.Application &&
      SC.Application.getComponent &&
      SC.Application.getComponent('PLP');

    return PLP && PLP.setDisplay && PLP.setDisplay({ display: display });
  }

  var FacetsItemsCollectionViewCtor =
    FacetsItemsCollectionView.FacetsItemsCollectionView ||
    FacetsItemsCollectionView;

  // Override TPL for the Facets.Items child view
  var lastCategoryId = null;

  _.extend(FacetsBrowseView.prototype, {
    template: facets_facet_browse_ext_tpl,

    beforeShowContent: _.wrap(
      FacetsBrowseView.prototype.beforeShowContent,
      function (fn) {
        var self = this;

        // 1) Run the original and WAIT for it to finish
        var originalPromise = fn.apply(this, _.toArray(arguments).slice(1));

        // 2) When finished, we should have the category in the model
        return jQuery.when(originalPromise).then(function () {
          // Try to get the id directly from the category model
          var categoryModel = (self.model && self.model.get('category')) || {};
          var categoryId = _.isFunction(categoryModel.get)
            ? categoryModel.get('internalid')
            : categoryModel.internalid || categoryModel.id;

          // Fallback 1: from the translator (facet "category" value = url/slug)
          if (
            !categoryId &&
            self.translator &&
            _.isFunction(self.translator.getFacetValue)
          ) {
            var catUrl = self.translator.getFacetValue('category');
            if (
              catUrl &&
              window.SC &&
              SC.CATEGORIES &&
              _.isFunction(SC.CATEGORIES.getCategoryForUrl)
            ) {
              var catObj = SC.CATEGORIES.getCategoryForUrl(catUrl, true);
              categoryId = catObj && (catObj.internalid || catObj.id);
            }
          }

          // Fallback 2: some implementations pass category in options
          if (!categoryId && self.options && self.options.category) {
            categoryId =
              self.options.category.internalid || self.options.category.id;
          }

          // Check if category changed
          if (categoryId !== lastCategoryId) {
            firstTimeIn = true;
            lastCategoryId = categoryId;
          }

          if (!categoryId) {
            // No category (free search or not loaded yet): continue without custom
            self.customCategoryData = {};
            return originalPromise;
          }

          // 3) Now call custom service with the categoryid
          self.customCategoryModel = new CustomCategoryModel();
          return self.customCategoryModel
            .fetch({ data: { categoryid: categoryId } })
            .then(function (resp) {
              self.customCategoryData = (resp && (resp.data || resp)) || {};

              if (
                isCustomPlpEnabled(categoryModel, self.customCategoryData) &&
                firstTimeIn &&
                !isDisplayListView()
              ) {
                setUrlDisplayParameterToList();
              }

              firstTimeIn = false;
            })
            .fail(function () {
              self.customCategoryData = {};
            });
        });
      }
    ),

    childViews: _.extend({}, FacetsBrowseView.prototype.childViews, {
      'Facets.Items': function () {
        var self = this;
        var categoryModel = this.model.get('category');
        var customCategoryData = this.customCategoryData || {};
        var isCustomPlpApplicable = isCustomPlpEnabled(
          categoryModel,
          customCategoryData
        );
        var display_option =
          _.find(this.itemsDisplayOptions, function (opt) {
            return opt.id === self.translator.getOptionValue('display');
          }) || this.itemsDisplayOptions[0];

        var default_tpl = display_option.template;
        var resolved_tpl = default_tpl;
        var viewsPerRow = parseInt(display_option.columns, 10);

        if (isCustomPlpApplicable && isDisplayListView()) {
          if (getPlpDisplay().id !== 'list') {
            setPlpDisplay('list');
          }

          resolved_tpl = customplp_tpl;
          viewsPerRow = 1;
        }

        return new FacetsItemsCollectionViewCtor({
          application: this.application,
          keywords: this.translator.getOptionValue('keywords'),
          collection: this.model.get('items'),
          viewsPerRow: viewsPerRow,
          cellViewTemplate: resolved_tpl
        });
      }
    }),

    getContext: _.wrap(FacetsBrowseView.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      var categoryModel = this.model && this.model.get('category');
      var customCategoryData = this.customCategoryData || {};
      var itemOptions = this.model.get('items').map(item => item.get('options'));
      var hasOptions = false;
      itemOptions.forEach( item => {
        if(item.find(option => option.attributes.cartOptionId === 'custcol290' || option.attributes.cartOptionId === 'custcol20')) {
          return hasOptions = true;
        }
      });
      context.showCustomPLPHeading =
        isCustomPlpEnabled(categoryModel, customCategoryData) &&
        getPlpDisplay().id === 'list';
      context.isCustomCategory =
        customCategoryData && customCategoryData.custrecord155 == 'T';
      context.hasOptions = hasOptions;
      return context;
    })
  });

  // Adding Color to the context of the item cell view
  _.extend(FacetsItemCellView.prototype, {
    getContext: _.wrap(FacetsItemCellView.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      context.hexCode = this.model.get('custitem_plp_custom_color_hex') || '';
      context.colorLabel =
        this.model.get('custitem_plp_custom_color_label') || '';
      context.showColor = !!(context.hexCode && context.colorLabel);
      var name = context.name || '';
      context.nameShort = name.length > 70 ? name.substring(0, 70) + '...' : name;
      context.requiresArtwork = itemRequiresArtwork(this.model);
      return context;
    })
  });

  // Adding the Add to Cart child view to the item cell view
  _.extend(FacetsItemCellView.prototype, {
    childViews: _.extend(FacetsItemCellView.prototype.childViews, {
      'CustomPLP.AddToCart': function () {
        return new CustomPLPAddToCartView({
          model: this.model,
          application: this.application
        });
      }
    })
  });
});
